/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SharedHotelPointsAmount
 */
export interface SharedHotelPointsAmount {
  /**
   *
   * @type {number}
   * @memberof SharedHotelPointsAmount
   */
  value: number;
}

/**
 * Check if a given object implements the SharedHotelPointsAmount interface.
 */
export function instanceOfSharedHotelPointsAmount(
  value: object
): value is SharedHotelPointsAmount {
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function SharedHotelPointsAmountFromJSON(
  json: any
): SharedHotelPointsAmount {
  return SharedHotelPointsAmountFromJSONTyped(json, false);
}

export function SharedHotelPointsAmountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelPointsAmount {
  if (json == null) {
    return json;
  }
  return {
    value: json["value"],
  };
}

export function SharedHotelPointsAmountToJSON(
  json: any
): SharedHotelPointsAmount {
  return SharedHotelPointsAmountToJSONTyped(json, false);
}

export function SharedHotelPointsAmountToJSONTyped(
  value?: SharedHotelPointsAmount | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
  };
}
